var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"100%"}},[_c('BasicToolbar',{attrs:{"name":"lingid"}}),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.tableConfig.headers,"items":_vm.links,"footer-props":{
      disableItemsPerPage: true,
      itemsPerPageText: null,
      itemsPerPageOptions: []
    },"options":{ itemsPerPage: 9 }},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('tr',{staticStyle:{"text-align":"center"}},[_c('td',[_c('a',{attrs:{"href":item.link}},[_vm._v(_vm._s(item.name))])])])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }